import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { PaymentFormSchemaValues } from 'src/features/payments/utils/formSchema';
import { Payment } from 'src/features/payments/utils/types';

const RESOURCE = '/payments/payment/';

type MutationFnType = typeof mutationFn;

const mutationFn = ({ ...data }: PaymentFormSchemaValues): Promise<Payment> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreatePayment };
